/** JSON_PATHS */
export const JSON_PATHS = {
  FORM_CENTER: {
    FORM_LIST_ITEM: {
      NAME: '$.name',
      KEYWORDS: '$.keywords',
      ID: '$.id',
      LISTED: '$.listed',
    },
    FORM_DETAILS: {
      FILE_UPLOAD: '$.fileUpload',
      FORM_INFO: {
        ID: '$.id',
        KEY: '$.key',
        NAME: '$.name',
        STACK: '$.stack',
        CONFIRMATION_TEXT: '$.confirmationText',
      },
      FORM_FIELD: {
        ID: '$.id',
        NAME: '$.dataKey',
        ORDER: '$.order',
        TYPE: '$.type',
        VALUE: '$.value',
        LABEL: '$.label',
        PLACEHOLDER: '$.placeholder',
        HINT: '$.hint',
        REQUIRED: '$.required',
        ERROR_TEXT: '$.errorText',
        HIDE: '$.hide',
        CONSTRAINTS: '$.constraints',
        ITEMS: '$.items',
        MAX_LENGTH: '$.maxValue',
        MIN_LENGTH: '$.minValue',
        LINK: '$.link',
      },
    },
  },
};
